import React from 'react';

// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Badge,
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  UncontrolledTooltip
} from "reactstrap";

// import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import axios from 'axios';
import { useState,useEffect } from "react";

import {IVR_CALLFLOW_LIST} from "../../constants";

import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import moment from "moment";

const Templatelist = () => {

  const[callflowLst,setCallflowLst] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(()=>{
    getCallflowList(currentPage);
    // getCampignList(currentPage);
  },[])

  // const getCallflowList=()=>{
  //   axios.get(IVR_CALLFLOW_LIST).then(res=>{
    
  //     setCallflowLst(res.data.message)}).catch(err=>console.log("error===>",err))
  // }

  const getCallflowList=(page)=>{
  
    setCurrentPage(page);
    axios.get(IVR_CALLFLOW_LIST+`?page=` +page).then(res=>{
      
      setCallflowLst(res.data);
      setIsLoading(false)
      
      }).catch(err=>console.log("error===>",err))
  }

  const PagingComponent = () => {
    return (
      <>
        {(() => {
          let paging = [];
          paging.push(
            <PaginationItem>
              <PaginationLink
                aria-label="Previous"
                onClick={(e) =>
                  currentPage > 1 ? getCallflowList(currentPage - 1) : ""
                }
              >
                <span aria-hidden={true}>
                  <i
                    aria-hidden={true}
                    className="tim-icons icon-double-left"
                  />
                </span>
              </PaginationLink>
            </PaginationItem>
          );
          for (let i = 1; i <= callflowLst.numOfPages; i++) {
            paging.push(
              <PaginationItem className={currentPage == i && "active"}>
                <PaginationLink onClick={(e) => getCallflowList(i)}>
                  {i}
                </PaginationLink>
              </PaginationItem>
            );
          }
          paging.push(
            <PaginationItem>
              <PaginationLink
                aria-label="Next"
                onClick={(e) =>
                  currentPage != callflowLst.numOfPages
                    ? getCallflowList(currentPage + 1)
                    : ""
                }
              >
                <span aria-hidden={true}>
                  <i
                    aria-hidden={true}
                    className="tim-icons icon-double-right"
                  />
                </span>
              </PaginationLink>
            </PaginationItem>
          );
          return paging;
        })()}
      </>
    );
  };
  return (
    <>
      <div className='content'>
      <Row>
          <Col className="mb-5" md="12">
            <Card>
            <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
              <CardBody>
              <TableContainer component={Paper} style={{"height":"440px" , "overflow-y":"scroll" }}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table"  responsive striped>
        <thead>
          <tr>
                    <th >Callflow  Name</th>
                    <th >Create Date</th>
                              
          </tr>
          
        </thead>
        <tbody>
          {callflowLst?.message?.map((item) => (
            <tr
              
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }} 
            >
              <td component="th" scope="row">
                {item.callflow_name}
              </td>
              <td >{moment(item.createdat).format('DD-MM-YYYY')}</td>
              
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
              </CardBody>
              <Row>
              <Col md="12">
                <Pagination className="pull-right">
                  <PagingComponent />
                </Pagination>
              </Col>
            </Row>
            </Card>
          </Col>
          
        </Row>
      </div>
    </>
  )
}

export default Templatelist
